import React from 'react';
import { Backdrop, CircularProgress, withStyles } from '@material-ui/core';

const styles = theme => ({
    container: {
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    }
});

const Loading = ({ classes }) => (
    <div className={classes.container}>
        <CircularProgress/>
    </div>
);

export default withStyles(styles)(Loading);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Loading.js